<!-- Button Input -->
<div class="w-full"
     [class.field]="formField">
  <button id="submit"
    type="submit"
    class="{{ inputClass }}"
    [disabled]="disabled"
    pButton
    pRipple>
    <span class="font-bold w-100">
      @if (iconClass) {
        <i class="{{ iconClass }}"
        ></i>
      }
      @if (label) {
        {{ label | translate }}
      }
      @if (iconClassAfter) {
        <i class="{{ iconClassAfter }}"
        ></i>
      }
    </span>
  </button>
</div>
